import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-light py-3 mt-auto">
      <Container>
        <p className="text-center mb-0">
          © {new Date().getFullYear()} Finwizz Financial Services Pvt Ltd. All rights reserved.
        </p>
      </Container>
    </footer>
  );
};

export default Footer;